/**
 * Print styles for PDF export
 * @module wellRegistrationTotals/styled/print
 */

/**
 * Base print styles shared by all print modes
 */
const basePrintStyles = `
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    box-shadow: none !important;
  }

  html, body {
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .no-print {
    display: none !important;
  }

  .selected-row,
  tr.selected-row,
  .MuiTableRow-root.selected-row {
    background-color: transparent !important;
    background: transparent !important;
  }

  .MuiCard-root,
  .MuiCardContent-root,
  .MuiPaper-root,
  .MuiTableContainer-root {
    box-shadow: none !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }

  .MuiCardContent-root:last-child {
    padding-bottom: 0 !important;
  }

  h4 {
    margin: 0 0 8px 0 !important;
    page-break-after: avoid;
    line-height: 1.2;
  }

  .MuiTableCell-root {
    line-height: 1.1 !important;
    border: 1px solid #ccc !important;
  }

  .MuiTableHead-root .MuiTableCell-root {
    font-weight: 600 !important;
  }

  thead {
    display: table-header-group !important;
  }

  tbody {
    display: table-row-group !important;
  }

  tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }
`;

/**
 * Landscape print styles for main table (wide format)
 */
export const landscapePrintStyles = `
  @page {
    size: landscape;
    margin: 0.3in;
  }

  ${basePrintStyles}

  h4 {
    font-size: 14pt;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: avoid !important;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 8pt !important;
  }

  .MuiTableCell-root {
    padding: 2px 4px !important;
    font-size: 8pt !important;
  }
`;

/**
 * Portrait print styles for drilldown table (narrow format)
 */
export const portraitPrintStyles = `
  @page {
    size: portrait;
    margin: 0.4in;
  }

  ${basePrintStyles}

  h4 {
    font-size: 12pt;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 7pt !important;
  }

  .MuiTableCell-root {
    padding: 2px 3px !important;
    font-size: 7pt !important;
  }
`;
